import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, ViewRef, HostListener, OnDestroy } from '@angular/core';
import { LifeStyleQuestion, depQuesRef, rangeData } from 'src/app/pages/medical-underwriting/model';
import { UtilityServiceForMedicalService } from 'src/app/pages/medical-underwriting/services/utility-service';
import * as UserDataConfig from '../../pages/user-details/config/user-data.config';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Tooltip } from 'src/app/model/tooltip';
import { Question } from 'src/app/model/question';
import { ASSETPATH } from 'src/app/constants/application-const';
import { SyncService } from '../../pages/medical-underwriting/services/sync.service';
import { UtilService, AnalyticsService } from '../../shared';
import { Router } from '@angular/router';

@Component({
  selector: 'app-grid-tiles-new',
  templateUrl: './grid-tiles-new.component.html',
  styleUrls: ['./grid-tiles-new.component.scss']
})
export class GridTilesNewComponent implements OnInit, OnDestroy {


  @Input() parent: UntypedFormGroup;
  @Input() controlName: string;
  @Input() question: LifeStyleQuestion;
  @Input() parentControlName: string;
  private rangeValidationData: rangeData[];
  @Input() gridTiles: LifeStyleQuestion[];
  @Input() editMode: boolean;
  @Output() GridCustomErrorEvent = new EventEmitter<depQuesRef[]>();
  @Output() editModelHandler: EventEmitter<any> = new EventEmitter();
  @Output() onDisplayMobileTooltipEmitter: EventEmitter<any> = new EventEmitter<any>();
  dependentQuestionsObjList: depQuesRef[] = [];

  @Input() questionId: string;
  tooltipObj: Tooltip;
  private gridValidationError: boolean = false;
  subscription: any;
  protected userInputDetail = UserDataConfig.ElementsConfig;
  private gridConfig: {
    toggleFlag: false
    imageText: "imageText"
    labelText1: "labelText1"
    labelText2: "labelText2"
    inputConfig: "inputConfig"
    toggleLabelText1: "toggleLabelText1"
    toggleLabelText2: "toggleLabelText2"
  };
  gridMaxReachedError: boolean = false;

  constructor(private utilityServiceForMedicalService: UtilityServiceForMedicalService,
    private syncService: SyncService,
    private fb: UntypedFormBuilder, private utilService: UtilService,
    private cdRef: ChangeDetectorRef,
    private analyticsService: AnalyticsService, private router: Router) {
    this.syncService.getRangeValidationJson().subscribe((res) => {
      this.rangeValidationData = res;
    });

  }

  ngOnInit() {
    this.initializeImagePath();
    this.initailaizeTooltip(this.question.helpText);
    this.prepareDependedQuestionListForGrid();
    this.setFormControlForDependentQues();

    this.checkRange(this.rangeValidationData);
    this.subscription = this.utilService.emitGrid.subscribe(
      () => {
        this.changeDetection();
      }
    );
    if (this.editMode) {
      // this.utilService.setGridCustomError(this.dependentQuestionsObjList);
      this.GridCustomErrorEvent.emit(this.dependentQuestionsObjList);
    }
  }

  initailaizeTooltip(value: string) {
    this.tooltipObj = new Tooltip(value, '', false);
  }


  prepareDependedQuestionListForGrid() {
    this.gridTiles.forEach(ques => {
      let valueToMatch = ques.responseValueByUser ? ques.responseValueByUser : ques.defaultResponseValue;
      if (ques.nextStep != null) {
        ques.nextStep.forEach(next => {
          if (next.nextStepSelectedResponse === valueToMatch) {
            next.nextStepValue.forEach(quesId => {
              let objList = this.utilityServiceForMedicalService.getQuestionListForGivenIds([quesId], null);
              let depQuesObjForSingleId = new depQuesRef();
              depQuesObjForSingleId.refQuesId = ques.id;
              depQuesObjForSingleId.depQuesObj = objList[0]; // alwayas adding one object
              this.dependentQuestionsObjList.push(depQuesObjForSingleId)
            });
          }
        });
      }
    });
  }

  setFormControlForDependentQues() {
    for (let i in this.dependentQuestionsObjList) {
      if (this.dependentQuestionsObjList[i]) {
        const tempFormGroup = this.fb.group({});
        let valueFromStore = this.dependentQuestionsObjList[i].depQuesObj.responseValueByUser
          ? this.dependentQuestionsObjList[i].depQuesObj.responseValueByUser : this.dependentQuestionsObjList[i].depQuesObj.defaultResponseValue;
        this.parent.addControl(this.dependentQuestionsObjList[i].depQuesObj.id, this.fb.control(valueFromStore, Validators.required));
      }
    }
  }

  initializeImagePath() {
    this.gridTiles.forEach(gridTile => {
      if (gridTile.id === 'LSQ032') { // ToDO: will be remvoed once we have got svg 
        gridTile.imagePath = ASSETPATH.images + gridTile.id + ASSETPATH.png;
      }
      else {
        gridTile.imagePath = ASSETPATH.images + gridTile.id + ASSETPATH.svg;
      }
    })
  }

  getDependetQueForTb(gridTileObj: LifeStyleQuestion): boolean {
    let depObj: LifeStyleQuestion;
    let match = false;
    for (let item in this.dependentQuestionsObjList) {
      if (this.dependentQuestionsObjList[item].refQuesId === gridTileObj.id && this.dependentQuestionsObjList[item].depQuesObj.controlType === 'InputBox') {
        match = true;
        break;
      }
    }
    return match;
  }

  getDependetQueIDForTb(gridTileObj: LifeStyleQuestion): string {
    let depObj: LifeStyleQuestion;
    this.dependentQuestionsObjList.forEach(item => {
      if (item.refQuesId === gridTileObj.id) {
        depObj = item.depQuesObj;
      }
    });
    return depObj.id;
  }

  getDependetQueResponseRange(gridTileObj: LifeStyleQuestion): string {
    let depObj: LifeStyleQuestion;
    this.dependentQuestionsObjList.forEach(item => {
      if (item.refQuesId === gridTileObj.id) {
        depObj = item.depQuesObj;
      }
    });
    this.rangeValidationData.forEach(range => {

      if (depObj.responseRange) {
        let temp = depObj.responseRange.split("=");
        let newResponseFromJson = temp[1];
        depObj.responseRange = newResponseFromJson === range.valueKey ? range.valueMax : depObj.responseRange;

      }
    })
    return depObj.responseRange;
  }

  toggleChangeEvtHandler(event, gridTileObj: LifeStyleQuestion) {
    if (this.parent.get(this.getDependetQueIDForTb(gridTileObj))) {
      this.parent.get(this.getDependetQueIDForTb(gridTileObj)).setValue(null);
      this.parent.get(this.getDependetQueIDForTb(gridTileObj)).markAsUntouched();
    }
  }

  checkRange(rangeValidationData: rangeData[]) {

    this.gridTiles.forEach(gridTile => {
      this.rangeValidationData.forEach(range => {

        if (gridTile.responseRange) {
          let temp = gridTile.responseRange.split("=");
          let newResponseFromJson = temp[1];
          gridTile.responseRange = newResponseFromJson === range.valueKey ? range.valueMax : gridTile.responseRange;

        }


      })
    });
  }

  changeDetection = () => {
    setTimeout(() => {
      if (this.cdRef && !(this.cdRef as ViewRef).destroyed) {
        this.cdRef.detectChanges();
      }
    });
  }
  checkErrorValidation = (gridTile): boolean => {
    let showError = false;
    if (gridTile && gridTile.nextStep) {
      gridTile.nextStep.forEach(next => {
        next.nextStepValue.forEach(childquestionId => {
          if (this.parent.get(childquestionId).touched
            && this.parent.get(childquestionId).errors && !this.parent.get(childquestionId).valid) {
            showError = true;
          }
        });
      });
    } else if (gridTile
      && this.parent.get(gridTile.id).touched
      && this.parent.get(gridTile.id).errors && !this.parent.get(gridTile.id).valid) {
      showError = true;
    }
    return showError;
  }

  @HostListener('document:alcoholMaxErrorEvent', ['$event'])
  handleAlcoholMaxErrorEvent(event) {
    this.gridMaxReachedError = false;
    if (event && event.detail && event.detail.questionIdToShowError && event.detail.validSum
      && (this.question.id === event.detail.questionIdToShowError)) {
      this.gridMaxReachedError = false;
    }
    else if (event && event.detail && event.detail.questionIdToShowError && (!event.detail.validSum)
      && (this.question.id === event.detail.questionIdToShowError)) {
      this.gridMaxReachedError = true;
    }
  }
  emitEditAlert = (val) => {
    this.editModelHandler.emit(val);
  }

  lifestyleInfoReceiver(value: LifeStyleQuestion) {
    if (value && this.utilityServiceForMedicalService.isPartOfWA(value.questionText)) {
      this.analyticsService.eventTrack({ type: 'Question', name: value.questionText, pageID: this.getCurrentScreenURL() });
    }
  }

  getCurrentScreenURL() {
    let screenName = this.utilService.getScreenNameFromURL(this.router.url);
    return screenName;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  displayMobileTooltipReceiver(){
    this.onDisplayMobileTooltipEmitter.emit();
  }
}
